import script from "./CustomResourceApplyHBHF.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyHBHF.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyHBHF.vue?vue&type=style&index=0&id=6eb1205c&lang=less&scope=true"

const __exports__ = script;

export default __exports__